'use client';

import { ErrorLayout } from '@/components/layout/ErrorLayout';
import { flex } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import type { NextPage } from 'next/types';
import Link from 'next/link';
import { Footer, Header, Main } from '@/components';

const Page: NextPage = () => (
  <>
    <Header />
    <Main>
      <ErrorLayout
        errorCode="500"
        title="An error has occurred."
        description="Sorry, we encountered an unexpected error."
      >
        <div
          className={flex({
            gap: '2',
          })}
        >
          <Button as={Link} href="/" variant="secondary">
            Go back home
          </Button>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </div>
      </ErrorLayout>
    </Main>
    <Footer />
  </>
);

export default Page;
